import React from 'react'
import styled from 'styled-components'

const MarketingWrapperOld = styled.div`
  vertical-align: middle;
`

const MarketingButtons = styled.div`
  display: inline-block;
  label:first-of-type {
    border-radius: 12px 0 0 12px;
  }
  label:last-of-type {
    border-radius: 0 12px 12px 0;
    border-left: 0px !important;
  }
`

export const MarketingInput = styled.input`
  position: absolute;
  left: -9999px;
  width: 0;
  height: 0;
`

const MarketingLabel = styled.label`
  font-size: 22px;
  font-family: ${(props) => props.theme.headerFontFamily};
  color: ${(props) => props.theme.headerFontColour};
  text-align: center;
  margin: 0;
  display: inline-block;
  width: 275px;

  @media (min-width: 555px) {
    transform: translateY(-65%);
  }
`

const ButtonLabel = styled.label`
  position: relative;
  display: inline-block;
  padding: 20px;
  width: 110px;
  font-size: 12px;
  line-height: 10px;
  letter-spacing: 1px;
  margin: 0 auto;
  text-align: center;
  overflow: hidden;
  cursor: pointer;
  text-transform: uppercase;
  color: #fff;
  padding: 20px 0;
  transition: background-color 300ms linear, color 300ms linear;
  border: 1px solid ${(props) => props.theme.marketingPreferencesColour};

  :has(> input:not(:checked)) {
    z-index: 1;
    background-color: #fff;
    color: ${({ theme }) => theme.marketingPreferencesColour};
    cursor: pointer;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  }

  :has(> input:disabled) {
    background-color: #dddddd;
    color: #000;
    cursor: default;
  }

  :has(> input:checked) {
    background-color: ${(props) => props.theme.marketingPreferencesColour};
    color: ${(props) => props.theme.button.textColour};
  }

  :focus-within {
    outline: 2px solid ${(props) => props.theme.marketingPreferencesColour};
    outline-offset: 2px;
  }
`

export const MarketingPreferences = ({ id, label, optIn, onChange }) => {
  return (
    <>
      <MarketingWrapperOld>
        <MarketingLabel className='label'>
          <span>{label}</span>
        </MarketingLabel>
        <MarketingButtons>
          {/*Opt In*/}

          <ButtonLabel
            id='MarketingPrefsYes'
            htmlFor={`marketingPreferences_${id}_optIn`}
          >
            Yes
            <MarketingInput
              disabled={optIn == null}
              type='radio'
              id={`marketingPreferences_${id}_optIn`}
              name={`marketingPreferences_${id}`}
              checked={optIn}
              onChange={() => onChange(true)}
            />
          </ButtonLabel>
          {/*Opt Out*/}
          <ButtonLabel
            id='MarketingPrefsNo'
            htmlFor={`marketingPreferences_${id}_optOut`}
          >
            No
            <MarketingInput
              disabled={optIn == null}
              type='radio'
              id={`marketingPreferences_${id}_optOut`}
              name={`marketingPreferences_${id}`}
              checked={optIn === false}
              onChange={() => onChange(false)}
            />
          </ButtonLabel>
        </MarketingButtons>
      </MarketingWrapperOld>
    </>
  )
}
